export default class {
  static payPerMonth(price, downpayment, yearRate, payYears) {
    const monthRate = (yearRate / 100.0) / 12.0;
    const payMonths = payYears * 12;
    const payPerMonth = ((price - downpayment) * monthRate * (1.0 + monthRate)**payMonths) / ((1.0 + monthRate)**payMonths - 1.0);
    return payPerMonth;
  }
}
